<div class="toolbar">
  <p-button label="Eliminar seleccionados" severity="danger" (click)="deleteSelected()" *ngIf="selectedRecords?.length"></p-button>
</div>

<p-table [value]="records$ | async" styleClass="p-datatable-striped" sortMode="single"
  [(selection)]="selectedRecords" dataKey="id" sortField="createdAt" [sortOrder]="-1">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="button-column"></th>
      <th pSortableColumn="file" id="file-column">Fichero <p-sortIcon field="title"></p-sortIcon></th>
      <th pSortableColumn="queryName" id="queryName-column">{{ 'EXPORT_LIST_COLUMNS.QUERY_NAME' | translate }}</th>
      <th pSortableColumn="viewMode" id="viewMode-column">{{ 'EXPORT_LIST_COLUMNS.VIEW_MODE' | translate }}</th>
      <th pSortableColumn="columnCount" id="columnCount-column">{{ 'EXPORT_LIST_COLUMNS.COLUMN_COUNT' | translate }}</th>
      <th pSortableColumn="status" id="status-column">Estado <p-sortIcon field="status"></p-sortIcon></th>
      <th pSortableColumn="createdAt" id="createdAt-column">Creado <p-sortIcon field="createdAt"></p-sortIcon></th>
      <th pSortableColumn="updatedAt" id="updatedAt-column">Actualizado <p-sortIcon field="updatedAt"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record">
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
        </div>
      </td>
      <td>
        <a *ngIf="record.status === 'finished'" href="{{apiUrl}}/exports/{{ record.file }}" target="_blank">{{ record.file }}</a>
        <span *ngIf="record.status !== 'finished'">Creando fichero</span>
      </td>
      <td>{{ record.queryName }}</td>
      <td>{{ record.viewMode }}</td>
      <td>{{ record.columnCount }}</td>
      <td>{{ record.status }}</td>
      <td>{{ record.createdAt | date: 'dd MMM yyyy, HH:mm' }}</td>
      <td>{{ record.updatedAt | date: 'dd MMM yyyy, HH:mm' }}</td>
    </tr>
  </ng-template>
</p-table>
